import React from 'react';
import { Container, Row, Col, Button } from 'reactstrap';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Container style={{ 
          minHeight: '400px', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          padding: '100px 0'
        }}>
          <Row>
            <Col className="text-center">
              <div style={{
                fontSize: '4rem',
                marginBottom: '20px'
              }}>
                ⚠️
              </div>
              <h2 style={{
                color: '#333',
                fontSize: '2rem',
                fontWeight: '600',
                marginBottom: '20px'
              }}>
                Oops! Something went wrong
              </h2>
              <p style={{
                color: '#666',
                fontSize: '1.1rem',
                marginBottom: '30px',
                maxWidth: '500px',
                margin: '0 auto 30px'
              }}>
                We're sorry, but something unexpected happened. Please try refreshing the page or contact us if the problem persists.
              </p>
              <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap' }}>
                <Button
                  className="btn-round"
                  style={{
                    background: 'linear-gradient(45deg, #667eea, #764ba2)',
                    border: 'none',
                    padding: '12px 30px',
                    borderRadius: '25px',
                    color: 'white',
                    fontWeight: '600',
                    fontSize: '1rem'
                  }}
                  onClick={() => window.location.reload()}
                >
                  Refresh Page
                </Button>
                <Button
                  className="btn-round"
                  style={{
                    background: 'transparent',
                    border: '2px solid #667eea',
                    padding: '12px 30px',
                    borderRadius: '25px',
                    color: '#667eea',
                    fontWeight: '600',
                    fontSize: '1rem'
                  }}
                  href="/contact"
                >
                  Contact Support
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
